import React from "react";

import { useNavigate } from "react-router-dom";

import Button from "../../Components/Button";
import { useAppDispatch, useAppSelector } from "../../Store/Hooks";
import { setCoverageReturnContext } from "../../Store/Reducers/CoverageSlice";
import { COVERAGE_OPS_PATH } from "../../Utils/Constants/RoleConstants";
import { orgPath } from "../../Utils/Helper/orgPath";

const CoverageReturnBanner: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const returnContext = useAppSelector(state => state.coverage.returnContext);
  if (!returnContext) return null;
  return (
    <div className="mb-3 flex items-center justify-between gap-3 rounded-lg border border-gray-200 bg-white px-4 py-3 text-sm text-gray-700">
      <span>
        Opened from Coverage · <strong>{returnContext.label}</strong>
      </span>
      <Button
        variant="outline-primary"
        onClick={() => {
          dispatch(setCoverageReturnContext(null));
          navigate(orgPath(COVERAGE_OPS_PATH));
        }}
      >
        Back to Coverage
      </Button>
    </div>
  );
};

export default CoverageReturnBanner;
